<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />
  <Breadcrumb />

  <div id="content" class="site-content" style="height: auto !important">
    <div id="downloadpage">
      <div >
        <!-- Hero Section -->
        <div class="hero-section">
          <div class="hero-image">
            <img src="@/assets/gb-whatsapp.webp" alt="GB WhatsApp APK" />
          </div>
          <h1 class="page-title">Download GB WhatsApp APK- Free & Safe</h1>
          <ul class="feature-list">
            <li>✅ Works on Android 5.0 and above</li>
            <li>✅ Lightweight APK, quick to download</li>
            <li>✅ Easy installation process</li>
            <li>✅ Safe and secure version</li>
          </ul>
          <p class="hero-description">
            Click the button below to start your download and enjoy all the latest features of <a href="/" class="jump-url">GBWhatsApp</a>.
          </p>
          <div class="download-button-container">
            <button class="download-btn dlbtn" @click="downloadfrom('hero')">
              GB WhatsApp APK- Free
            </button>
          </div>
        </div>

        <!-- Why Download Section -->
        <div class="why-download-section">
          <h2 class="section-title">Why Download from Here?</h2>
          <ul>
            <li>Always updated to the newest version</li>
            <li>Virus-free and secure APK file</li>
            <li>Fast servers for quick download</li>
            <li>Step-by-step install guide available</li>
          </ul>
        </div>

        <!-- Installation Guide Section -->
        <div class="install-guide-section">
          <h2 class="section-title">How to Install GBWhatsApp APK (2026)</h2>
          <div class="install-steps">
            <div class="step">
              <h3 class="step-title">1. Download the APK</h3>
              <p class="step-description">
                Tap the download button above to get the latest <a href="/" class="jump-url">GBWhatsApp APK</a> v18.80 file on your Android device.
              </p>
            </div>
            <div class="step">
              <h3 class="step-title">2. Enable Unknown Sources</h3>
              <p class="step-description">
                Go to <strong>Settings</strong> → <strong>Security</strong> → <strong>Install unknown apps</strong> and allow your browser or file manager to install APK files.
              </p>
            </div>
            <div class="step">
              <h3 class="step-title">3. Install the APK</h3>
              <p class="step-description">
                Open the downloaded APK file and tap <strong>Install</strong>. Wait for the installation to complete.
              </p>
            </div>
            <div class="step">
              <h3 class="step-title">4. Open GBWhatsApp & Verify</h3>
              <p class="step-description">
                Launch <strong>GBWhatsApp</strong>, verify your phone number, and restore your chats if needed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import Breadcrumb from '@/components/Breadcrumb.vue';
import HeadNav from '@/components/HeadNav.vue';

const DOWNLOAD_APK_URL = 'https://file.wave-gb.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: DOWNLOAD_APK_URL,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    Breadcrumb,
    HeadNav,
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    this.apk = DOWNLOAD_APK_URL;
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      this.$router.push('/blog/');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = DOWNLOAD_APK_URL;
          } else {
            this.apk = DOWNLOAD_APK_URL;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = DOWNLOAD_APK_URL;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = DOWNLOAD_APK_URL;
          }
        });
    },
    download() {
      this.$global.download(DOWNLOAD_APK_URL);
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
.feature-list li{
  @media screen and (min-width: 768px) {
    margin-left: 5rem;
  }
  @media screen and (max-width: 768px) {
  margin-left: 0;
  }
}

.download-btn {
	background: linear-gradient(170deg, #000851 0%, #1697BB 100%) !important;
	color: #fff !important;
	border: none !important;
	font-size: 20px !important;
	font-weight: 700 !important;
	letter-spacing: 0.2px;
	padding: 16px 40px !important;
	border-radius: 8px !important;
	margin: 20px 0;
	display: inline-block;
	cursor: pointer;
	transition: all 0.4s ease;
	box-shadow: 0 4px 12px rgba(0, 8, 81, 0.3);
	text-decoration: none;
	
	&:hover {
		background: linear-gradient(170deg, #1697BB 0%, #000851 100%) !important;
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(0, 8, 81, 0.4);
		transition: all 0.4s ease;
	}
	
	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 8px rgba(0, 8, 81, 0.3);
	}
}

#downloadpage .hero-section .feature-list{
  max-width: 100%;
}

</style>
